import { type ComponentProps, type MouseEvent } from 'react';
import { hasCoarsePointer } from '@/shared/utils/pointer';
import FormInput from './FormInput';

type Props = Omit<ComponentProps<typeof FormInput>, 'type' | 'onClick'>;

export default function DateInput(props: Props) {
  return <FormInput type="date" onClick={openPickerOnTouch} {...props} />;
}

function openPickerOnTouch(event: MouseEvent<HTMLInputElement>) {
  const input = event.currentTarget;
  if (input.disabled || !hasCoarsePointer()) return;

  input.showPicker();
}
